import type { BooleanScaleData, ScaleSelectorProps } from "@qendo/profile/journal";
import type { ScaleType } from "@qendo/trackables";
import { CheckboxInput } from "~/components/form/CheckboxInput";
import { FieldGroup } from "~/components/form/FieldGroup";

export type BooleanSelectorProps = ScaleSelectorProps<ScaleType.boolean>;

export const BooleanSelector = ({ value, onUpdateScale, disabled, label, zIndex }: BooleanSelectorProps) => {
    const changeChecked = (c: boolean) => {
        if (value.value !== c) {
            onUpdateScale({ ...value, value: c } as BooleanScaleData);
        }
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <CheckboxInput label={label ?? ""} value={value.value} onValueChange={changeChecked} disabled={disabled} />
        </FieldGroup>
    );
};
